import { RefObject, useEffect, useRef, useState } from 'react';

import { DESK_SIDEBAR_WIDTH_LS_KEY } from '../constants/LocalStorage';

let sideBarWidthInit: number | string = 252;
try {
  const LSSidebarWidth = window.localStorage.getItem(DESK_SIDEBAR_WIDTH_LS_KEY);
  if (LSSidebarWidth) {
    sideBarWidthInit = LSSidebarWidth;
  }
} catch (e) {
  console.error(e);
}

export const MIN_WIDTH_TICKETS_SIDEBAR = 252;
export const MAX_WIDTH_TICKETS_SIDEBAR = 400;
export const TICKETS_SIDEBAR_TRESHOLD = 75; // in %

export function useResizeTicketsSidebar({ refSidebar }: { refSidebar: RefObject<HTMLDivElement> }) {
  const isResizing = useRef(false);
  const [sideBarWidth, setSideBarWidth] = useState(sideBarWidthInit);

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!isResizing.current || !refSidebar.current) return;

      const sidebarLeft = refSidebar.current.getBoundingClientRect().left;
      const newWidth = Math.min(
        MAX_WIDTH_TICKETS_SIDEBAR,
        Math.max(MIN_WIDTH_TICKETS_SIDEBAR, e.clientX - sidebarLeft),
      );
      setSideBarWidth(newWidth);
    };

    const handleMouseUp = (e: MouseEvent) => {
      if (!isResizing.current || !refSidebar.current) return;
      isResizing.current = false;
      document.body.style.cursor = ''; // Reset cursor
      const sidebarLeft = refSidebar.current.getBoundingClientRect().left;
      const newWidth = Math.min(
        MAX_WIDTH_TICKETS_SIDEBAR,
        Math.max(MIN_WIDTH_TICKETS_SIDEBAR, e.clientX - sidebarLeft),
      );
      setLocalStorageValue(DESK_SIDEBAR_WIDTH_LS_KEY, newWidth.toString());
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, []);

  const handleMouseDown = (e: React.MouseEvent) => {
    e.preventDefault();
    isResizing.current = true;
    document.body.style.cursor = 'ew-resize';
  };

  return {
    sideBarWidth,
    handleMouseDown,
  };
}

type Callback = (key: string, newValue: string | null) => void;

const listeners = new Set<Callback>();

export const subscribeToStorageChange = (callback: Callback) => {
  listeners.add(callback);
  return () => {
    listeners.delete(callback);
  };
};

export const setLocalStorageValue = (key: string, value: string) => {
  localStorage.setItem(key, value);
  listeners.forEach((cb) => cb(key, value));
};
